module.exports = __webpack_public_path__ + "static/img/footer_science.325c4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/footer_science.png
// module id = koYz
// module chunks = 1